import { graphql, useStaticQuery } from 'gatsby'

const useNavigationQuery = () => {
  const data = useStaticQuery(graphql`
    query NavigationQuery {
      links: contentfulNavigationBar(slug: { eq: "navigation-bar" }) {
        pages {
          ... on ContentfulPage {
            id
            headerNavTitle
            name
            slug
          }
          ... on ContentfulNavigationSection {
            id
            title
            pages {
              __typename
              ... on ContentfulPack {
                id
                name
                slug
                slugUrl
              }
              ... on ContentfulPage {
                id
                headerNavTitle
                name
                slug
              }
            }
          }
        }
      }
      trade: contentfulNavigationBar(slug: { eq: "trade-navigation-bar" }) {
        pages {
          ... on ContentfulPage {
            id
            headerNavTitle
            name
            path
            slug
          }
        }
      }
    }
  `)

  return data
}

export default useNavigationQuery
